import { apiRequest } from './apiClient';

export const getOperators = async () => {
  return apiRequest('/operators');
};

export const createOperator = async (operatorData) => {
  return apiRequest('/operators', { method: 'POST', body: operatorData, modelLabel: 'operador' });
};

export const updateOperator = async (id, operatorData) => {
  return apiRequest(`/operators/${id}`, { method: 'PUT', body: operatorData, modelLabel: 'operador' });
};

export const deleteOperator = async (id) => {
  return apiRequest(`/operators/${id}`, { method: 'DELETE', modelLabel: 'operador' });
};
